export * from './delete-foto-kategorie.service';
export * from './delete-foto-kategorie.service.module';